module.exports = __webpack_public_path__ + "static/media/5790-removebg.bb7e2464.png";